module.exports = __webpack_public_path__ + "static/img/index-title-03.6ff9c222.png";